/* eslint-disable security/detect-object-injection */
/* eslint-disable no-restricted-globals */
/* eslint-disable react/no-array-index-key */
/* eslint-disable import/no-unresolved */
// eslint-disable-next-line import/no-unresolved
import Resources from "src/config/Resources";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { SET_IS_LOGGED_IN, saveNewLeadDetailsAction } from "src/redux/Actions/common";
import StorageService from "src/utils/Storage/storageService";
import { colors, roundsOfEffect } from "src/helpers/Header";
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import {
  accessCreateLeadOption,
  partners,
  roleIDs,
  showPartnerLogo,
  url
} from "src/config/constant";
// import { useEffect } from "react";
import { useMutation } from "react-query";
import logoutCall from "src/services/Logout";

interface Props {
  isEnable: boolean;
}

function Header({ isEnable = true }: Props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const partnerId = useAppSelector((state) => state.common?.leadDetails?.partnerId);
  const user = StorageService.getFromLocalStorage("user");
  const userPartnerId = user?.partnerCode || "";

  const { mutate: logoutAPI } = useMutation(["logout"], logoutCall, {
    retry: false,
    onSettled: () => {
      navigate("/");
    }
  });

  const checkPartnerName = () => {
    const isDasboardUrl = window.location.href?.includes("/dashboard");
    if (!isDasboardUrl) {
      return partners[partnerId?.toUpperCase() as keyof typeof partners];
    }
    return null;
  };

  const logOut = () => {
    // api call
    const userId = StorageService.getFromLocalStorage("user")?.id;
    dispatch(SET_IS_LOGGED_IN(false));
    StorageService.removeKeyFromLocalStorage("token");
    StorageService.removeKeyFromLocalStorage("user");
    localStorage.removeItem("leadId");
    logoutAPI(userId);
  };

  // useEffect(() => {
  //   window.addEventListener("beforeunload", () => {
  //     logOut();
  //   });
  // }, []);

  const isDashboardUrl = location.pathname.includes("/dashboard");
  return (
    <div className="shadow-md">
      <div className="h-1 flex">
        {Array(roundsOfEffect)
          .fill(1)
          ?.map((_, index: number) => (
            <div key={index} className={`flex-1 ${colors[index % colors.length]}`} />
          ))}
      </div>
      <div className="h-17.5 border-b border-desiredDawn flex justify-between items-center px-3 md:pl-8.5 md:pr-10.75">
        <div className="flex space-x-2 flex-1">
          <div
            className={`${isEnable ? "cursor-pointer" : ""}`}
            onClick={() => {
              if (isEnable) {
                dispatch(SET_IS_LOGGED_IN(false));
                localStorage.removeItem("leadId");
                navigate("/dashboard");
              }
            }}
            onKeyDown={() => {
              if (isEnable) {
                dispatch(SET_IS_LOGGED_IN(false));
                localStorage.removeItem("leadId");
                navigate("/dashboard");
              }
            }}
            role="presentation"
          >
            <img
              alt="afli-logo"
              className="!w-[95px] md:!w-[118px]"
              src={Resources.images.Header.afliHero}
            />
          </div>
          {Object.values(partners)?.includes(checkPartnerName()!) &&
          !!showPartnerLogo[partnerId] ? (
            <div className="flex items-center justify-center">
              <img
                alt={checkPartnerName()!}
                className="!w-[95px] md:!w-[118px]"
                src={showPartnerLogo[partnerId]}
              />
            </div>
          ) : null}
        </div>
        {isEnable && (
          <div className="flex space-x-2 flex-1 justify-end">
            {(user?.role === roleIDs.nbgo ||
              user?.role === roleIDs.superAdmin ||
              user?.role === roleIDs.admin ||
              user?.role === roleIDs.irm ||
              user?.role !== roleIDs.partnerAdmin ||
              (user?.role === roleIDs.bankEmployee &&
                accessCreateLeadOption?.includes(userPartnerId))) &&
              isDashboardUrl && (
                <div
                  className="mr-[5px] lg:mr-[0px] pl-6"
                  onClick={() => {
                    window.location.href = url.create_lead_details;
                    dispatch(saveNewLeadDetailsAction({}));
                  }}
                  role="presentation"
                >
                  <p className="font-lato text-hotShot font-semibold text-xs lg:text-base cursor-pointer sm:mr-7.75">
                    Create Lead
                  </p>
                </div>
              )}
            <div
              onClick={() => {
                dispatch(SET_IS_LOGGED_IN(false));
                localStorage.removeItem("leadId");
                navigate("/dashboard");
              }}
              onKeyDown={() => {
                dispatch(SET_IS_LOGGED_IN(false));
                localStorage.removeItem("leadId");
                navigate("/dashboard");
              }}
              className="mr-[5px] lg:mr-[0px]"
              role="presentation"
            >
              <p className="font-lato text-hotShot font-semibold text-xs lg:text-base mr-1 ml-1 sm:mr-7.75 cursor-pointer">
                Leads Inbox
              </p>
            </div>
            <div
              onClick={() => {
                logOut();
              }}
              className="mr-[5px] lg:mr-[0px]"
              role="presentation"
            >
              <p className="font-lato text-shoeWax opacity-50 font-semibold text-xs lg:text-base cursor-pointer">
                Logout
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Header;
